import React from "react";
import { useTranslation } from "react-i18next";

const KitchenWhatIsIncluded = () => {
  const { t } = useTranslation();
  return (
    <div>
      <label>
        <strong>{t("floor.whatsIncludedInPackage")}</strong>
      </label>
      <ul>
        <li>Customer support specialist</li>
        <li>Kitchen design & drawings</li>
        <li>Cap plumbing pipes</li>
        <li>Electrical minor adjustments</li>
        <li>Installation of new kitchen cabinets</li>
        <li>Trim finish</li>
        <li>Trash and debris removal from job site</li>
        <li>1 year Comprehensive Warranty covering workmanship</li>
        <li>Optional: tiled backsplash</li>
        <li>Optional: supply new kitchen cabinets</li>
        <li>Optional: countertops supply and installation</li>
        <li>Materials free delivery**</li>
      </ul>
      <div className="profilePadding10"></div>
      <label>
        <strong>{t("floor.howLongTheProcessTakes")}</strong>
      </label>
      <ul>
        <li> Between 1 to 3 weeks*</li>
      </ul>
      <div className="profilePadding40"></div>
      <span>*Might differ according to size</span>
      <br />
      <span>**Only if acquired through Anyhnb </span>
    </div>
  );
};

export default KitchenWhatIsIncluded;
